import { ICrewLicensures, ICrewLicensuresOption, ICrewLicensureValues } from '../../../features/crew/store/crew.types'
import { IPcr } from '../../../features/pcr/store/pcr.types'
import Logger from '../../../services/logger.service'

export const moveLicensures = (pcr: IPcr): IPcr => {
  try {
    const crew = pcr.crew

    const updatedCrew = crew.map((crewMember) => {
      const licensures = crewMember.licensures
      if (!licensures) return crewMember

      if (Array.isArray(licensures) && licensures.length !== 0) {
        const updatedLicensures: ICrewLicensures = {}

        licensures.forEach((licensure: ICrewLicensuresOption) => {
          if (licensure.certType) {
            const licensureValues: ICrewLicensureValues = {
              id: licensure.stateId,
              crewLevel: licensure.crewLevel,
              isCertType: true,
            }
            updatedLicensures[licensure.certType] = licensureValues
          } else if (licensure.state) {
            const licensureValues: ICrewLicensureValues = {
              id: licensure.stateId,
              type: licensure.stateType,
              isCertType: false,
            }
            updatedLicensures[licensure.state] = licensureValues
          }
        })

        crewMember.licensures = updatedLicensures
      }
      return crewMember
    })

    pcr.crew = updatedCrew
    return pcr
  } catch (error) {
    Logger.error(`Error executing schema upgrade script moveLicensures: ${error}`)
    throw error
  }
}
